import React from 'react'
import withIconStyles from '@edulastic/icons/src/HOC/withIconStyles'
import SVG from '@edulastic/icons/src/common/SVG'

const IconAlignLeft = (props) => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width="15.282"
    height="12.008"
    viewBox="0 0 15.282 12.008"
    {...props}
  >
    <g transform="translate(0 -54.817)">
      <g transform="translate(0 54.817)">
        <path
          d="M.546,166.639h13.1a.553.553,0,0,0,.546-.546V165a.553.553,0,0,0-.546-.546H.546a.525.525,0,0,0-.384.162A.525.525,0,0,0,0,165v1.092a.524.524,0,0,0,.162.384A.525.525,0,0,0,.546,166.639Z"
          transform="translate(0 -161.181)"
        />
        <path
          d="M.546,57H10.37a.553.553,0,0,0,.546-.546V55.363a.553.553,0,0,0-.546-.546H.546a.525.525,0,0,0-.384.162A.525.525,0,0,0,0,55.363v1.092a.525.525,0,0,0,.162.384A.525.525,0,0,0,.546,57Z"
          transform="translate(0 -54.817)"
        />
        <path
          d="M15.12,383.882a.525.525,0,0,0-.384-.162H.546a.525.525,0,0,0-.384.162.525.525,0,0,0-.162.384v1.092a.525.525,0,0,0,.162.384.526.526,0,0,0,.384.162H14.736a.553.553,0,0,0,.546-.546v-1.092A.525.525,0,0,0,15.12,383.882Z"
          transform="translate(0 -373.896)"
        />
        <path
          d="M.546,276.27H11.462a.554.554,0,0,0,.546-.546v-1.092a.554.554,0,0,0-.546-.546H.546a.525.525,0,0,0-.384.162.525.525,0,0,0-.162.384v1.092a.524.524,0,0,0,.162.384A.525.525,0,0,0,.546,276.27Z"
          transform="translate(0 -267.537)"
        />
      </g>
    </g>
  </SVG>
)

export default withIconStyles(IconAlignLeft)
